import { useEffect, useState } from "react";
import { Alert, Col, Container, Nav, Row, Tab, Tabs } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loading from "../../components/loading/Loading";
import { getCoordinadoresDeEquipoRoles, getEquipo, getTemasByEtapa, setOrgToken } from "../../controllers/org";
import { useAuth } from "../../components/auth/AuthProvider";
import Members from "./Members";
import ReporteTema from "../../components/equipo/ReporteTema";
import { CheckCircleFill, Circle } from "react-bootstrap-icons";
import EquipoAddMembers from "../../components/comunidad/equipoAddMembers";

function Equipo() {
  const { token } = useAuth();
  const params = useParams();
  const [data, setData] = useState();
  const [alert, setAlert] = useState();
  const [temas, setTemas] = useState([]);
  const [temaIdx, setTemaIdx] = useState(0);
  const [coordinador, setCoordinador] = useState();
  setOrgToken(token);

  useEffect(() => {
    loadEquipo();
  }, []);

  async function loadEquipo() {
    try {
      const d = await getEquipo(params.teamId);
      const temas = await getTemasByEtapa(d.teamDetails.etapa_id);
      let coordinadoresDeEquipoRoles = await getCoordinadoresDeEquipoRoles();
      setData(d);
      setTemas(temas);

      const c = d.teamMembers.rows.find(m => {
        if (m.membership_roles.find(mr => mr.role_id === coordinadoresDeEquipoRoles[d.teamDetails.etapa.type])) {
          return m;
        }
      });
      if (c) {
        setCoordinador(c.label);
      }
    }
    catch(e) {
      console.log('Error loading team:', e);

      if (e.status === 403) {
        setAlert(<Alert variant="danger">
          <p><b>Error cargando equipo</b></p>
          <p>Parece que no tienes permiso para ver este equipo.</p>
        </Alert>);
      }
      else {
        setAlert(<Alert variant="warning">
          <p><b>Error cargando equipo</b></p>
          <p>Ocurrió un error al cargar la información del equipo. Por favor intenta de nuevo más tarde.</p>
        </Alert>);
      }
    }
  }

  function onEquiperoAddition(newEquiperos) {
    loadEquipo();
  }

  if ( (!data || !temas)  && alert) {
    return <Container className="mt-3">
      <Col><Row>{alert}</Row></Col>
    </Container>
  }
  else if (!data || !temas) {
    return <Container>
      <Row><h1>Equipo {params.teamId}</h1></Row>
      <Row><Loading text="Cargando información del equipo..."/></Row>
    </Container>
  }

  const tema = temas[temaIdx];
  const reporte = data.teamReports.filter(r => r.tema_id === tema.tema_id)[0] || {};

  let teamLabel = '';
  if (coordinador) {
    teamLabel = `Equipo coordinado por: ${coordinador}`;
  }
  else {
    teamLabel = `Equipo ${params.teamId}`;
  }

  return <Container className="public-page-container">
    <Row><h1>{teamLabel}</h1></Row>
    <Row>
      <Tabs defaultActiveKey={window.location.hash.replace('#', '') || 'temas'}>
        <Tab eventKey="temas" title="Temas">
            <Row>
              <Col lg={2}>
                <select name="tema-select" onChange={(ev) => setTemaIdx(parseInt(ev.target.value))} value={temaIdx} className="d-lg-none tema-select">
                  {temas.map((t, i) =>
                    <option value={i}>Tema {t.tema_num} { data.teamReports.filter(r => r.tema_id === t.tema_id).length ? '- Completo' : '- Pendiente'}</option>
                  )}
                </select>
                <Nav variant="pills" className="flex-column d-none d-lg-block">
                  {temas.map((t, i) =>
                    <Nav.Item key={`tema-${t.tema_id}`}>
                      <Nav.Link eventKey={`tema-${t.tema_id}`} active={temaIdx === i} data-temaidx={i} onClick={e => {setTemaIdx(parseInt(e.currentTarget.dataset.temaidx))} }>
                        Tema {t.tema_num} { data.teamReports.filter(r => r.tema_id === t.tema_id).length ? <CheckCircleFill /> : <Circle />}
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </Col>
              <Col lg={10}>
                <ReporteTema tema={tema} reporte={reporte} equipo={data} onSubmit={loadEquipo} />
              </Col>
            </Row>
        </Tab>
        <Tab eventKey="miembros" title="Miembros">
          <EquipoAddMembers teamId={data.teamDetails.team_id} comunidadId={data.teamDetails.comunidad_id} etapaId={data.teamDetails.etapa_id} onEquiperoAddition={onEquiperoAddition} />
          <Members preloadedMembers={data.teamMembers.rows} comunidadId={data.teamDetails.comunidad_id} etapaId={data.teamDetails.etapa_id} equipoId={params.teamId} showYearSelector={false} />
        </Tab>
      </Tabs>
    </Row>
  </Container>
}

export default Equipo;
